var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9679 2.52124H15.4465C8.12724 2.52124 2.18701 8.44389 2.18701 15.7582V41.2288C2.18701 48.5431 8.12724 54.4658 15.4465 54.4658H40.9679C48.2871 54.4658 54.2273 48.5431 54.2273 41.2288V15.7582C54.2273 8.44389 48.2871 2.52124 40.9679 2.52124Z",
    fill: "#242938",
    stroke: "#001E36",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2075 32.0427C30.1411 32.0427 31.7084 30.4783 31.7084 28.5488C31.7084 26.6192 30.1411 25.0548 28.2075 25.0548C26.274 25.0548 24.7065 26.6192 24.7065 28.5488C24.7065 30.4783 26.274 32.0427 28.2075 32.0427Z",
    fill: "#00D8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2075 21.4447C32.908 21.4447 37.2746 22.1178 40.567 23.2492C44.5339 24.6121 46.9729 26.678 46.9729 28.5488C46.9729 30.4982 44.3881 32.693 40.1281 34.1015C36.9075 35.1664 32.6695 35.7223 28.2075 35.7223C23.6328 35.7223 19.3007 35.2005 16.0438 34.0897C11.9232 32.6842 9.44141 30.4611 9.44141 28.5488C9.44141 26.6932 11.7702 24.6432 15.6814 23.2824C18.986 22.1324 23.4604 21.4447 28.2068 21.4447H28.2075Z",
    stroke: "#00D8FF",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.011 25.0172C24.3593 20.9535 27.1249 17.5146 29.7517 15.2335C32.9163 12.4847 35.9282 11.4082 37.5519 12.3426C39.244 13.3164 39.8578 16.6478 38.9524 21.0344C38.2683 24.3506 36.6331 28.2922 34.4039 32.1498C32.1184 36.1049 29.5015 39.5895 26.9106 41.8496C23.632 44.7098 20.4623 45.7449 18.8024 44.7896C17.1918 43.8633 16.5759 40.8254 17.3486 36.7641C18.0015 33.3325 19.6399 29.1207 22.0103 25.0172H22.011Z",
    stroke: "#00D8FF",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0168 32.1601C19.6619 28.101 18.0586 23.9916 17.3894 20.5812C16.5838 16.472 17.1533 13.3303 18.7756 12.3931C20.4662 11.4163 23.6645 12.5493 27.0201 15.523C29.5573 17.7712 32.1625 21.1529 34.3981 25.0069C36.6901 28.9582 38.408 32.9613 39.0762 36.3302C39.9218 40.5935 39.2374 43.8509 37.5791 44.8089C35.9701 45.7386 33.0256 44.7544 29.8859 42.0579C27.2331 39.7798 24.395 36.2598 22.0168 32.1601Z",
    stroke: "#00D8FF",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/react.2fe6942a77730223dac7bc11746d94a3.svg";
export { ForwardRef as ReactComponent };